<template>
  <div class="box_oun">
    <div class="Company_profile_box">
      <div class="info">
        <div>
          四川升和药业股份有限公司（下称“公司”），是一家集药品研发、生产、销售为一体的高新技术企业。
        </div>
        <div></div>
        <div>
          公司主产品线为颗粒剂产品线、滴眼液产品线、痛风专科用药、注射剂产品线、咳嗽专科用药以及基本药物系列。
        </div>
      </div>
      <div class="profile_box">
        <div class="for_box" :class="{ for_box1: index !== 0, actives: item.class }" v-for="(item, index) in profileArr"
          :key="index">
          <div class="number_box">
            <div class="name">{{ item.name }}</div>
            <div class="num">
              <countTo class="countTo" :start="0" :end="item.number" :times="120" :speed="120"></countTo>
              <span class="txt_ou">{{ item.text }}</span>
            </div>
          </div>
          <div class="icon_box" :class="{ act_clasee: item.class }">
            <img :src="item.icon" alt="" />
          </div>
        </div>
      </div>
      <div class="picety">
        <img src="../../assets/AboutImg/clouds.png" />
      </div>
      <div class="culture_box">
        <div class="culture_center_box_pc">
          <div class="culture_for_box" v-for="(item, index) in CompanyIntro" :key="index">
            <div class="img_left_box" v-if="index % 2 === 0">
              <div class="img animate__animated animate__slow" :class="{ animate__fadeInLeft: anmintesto }">
                <img :src="item.image" alt="" />
              </div>
              <div class="info_box animate__animated animate__slow" :class="{ animate__fadeInRight: anmintesto }">
                <div class="info_mty">{{ item.info }}</div>
              </div>
            </div>
            <div class="img_right_box" v-else>
              <div class="info_box animate__animated animate__slower" :class="{ animate__fadeInLeft: anmintesto }">
                <div class="info_mty">{{ item.info }}</div>
              </div>
              <div class="img animate__animated animate__slower" :class="{ animate__fadeInRight: anmintesto }">
                <img :src="item.image" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="culture_center_box">
          <div class="culture_for_box" v-for="(item, index) in CompanyIntro" :key="index">
            <div class="img_left_box">
              <div class="img"><img :src="item.image" alt="" /></div>
              <div class="info_box">
                <div class="info_mty">{{ item.info }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-number-scroll";
import { getCompanyIntro } from "../../api/apis";

export default {
  name: "CompanyProfile",
  components: {
    countTo,
  },
  data() {
    return {
      //  公司简介模块数据
      profileArr: [
        {
          name: "品种",
          icon: require("../../assets/AboutImg/establish.png"),
          number: 121,
          text: "个",
          class: "true",
        },
        {
          name: "批准文号",
          icon: require("../../assets/AboutImg/register.png"),
          number: 200,
          text: "个",
        },
        {
          name: "占地面积",
          icon: require("../../assets/AboutImg/service.png"),
          number: 37.2,
          text: "万平米",
          class: "true",
        },
        {
          name: "发明专利",
          icon: require("../../assets/AboutImg/Copyright.png"),
          number: 20,
          text: "项",
        },
      ],
      CompanyIntro: [],
      anmintesto: false,
    };
  },
  created() {
    this.GetCompanyIntro();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (document.body.clientWidth < 1200) {
      } else {
        if (scroll > 886) {
          this.anmintesto = true;
        }
      }
    },
    GetCompanyIntro() {
      getCompanyIntro().then((res) => {
        this.CompanyIntro = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.box_oun {
  padding-bottom: 200px;

  .Company_profile_box {
    .info {
      width: 1200px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 28px;
      color: #666666;
      margin: 0 auto;
      text-align: center;
    }

    .profile_box {
      width: 1200px;
      height: 100px;
      margin: 50px auto 0;
      display: flex;

      .for_box {
        width: 25%;
        height: 100%;
        display: flex;
        justify-content: center;

        .number_box {
          width: auto;
          height: 100%;
          margin-left: 30px;

          .name {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #1a1a1a;
            opacity: 1;
          }

          .num {
            margin-top: 20px;

            .countTo {
              font-size: 46px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 61px;
              color: #2c7be5;
              opacity: 1;
            }

            span {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 19px;
              color: #1a1a1a;
              opacity: 1;
              margin-left: 10px;
            }
          }
        }

        .icon_box {
          width: auto;
          height: auto;
          margin-right: 30px;

          img {
            width: 42px;
            height: 42px;
          }
        }
      }

      .for_box1 {
        border-left: 1px solid #909090;
      }
    }

    .picety {
      margin: 64px auto 50px;
      width: 100%;
      height: 180px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .culture_box {
      width: 100%;
      height: auto;

      .culture_center_box {
        display: none;
      }

      .culture_center_box_pc {
        width: 1200px;
        min-height: 300px;
        margin: 0 auto;
        display: block;

        .culture_for_box {
          width: 100%;
          margin-top: 50px;
          height: 400px;

          overflow: hidden;

          .img_left_box {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;

            .img {
              width: 742px;
              height: 100%;
              overflow: hidden;
              opacity: 0;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: all 1s;
              }
            }

            .info_box {
              width: 425px;
              height: 400px;
              display: flex;
              align-items: center;
              opacity: 0;

              .info_mty {
                white-space: pre-wrap;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 28px;
                color: #666666;
                transition: all 1s;
              }
            }

            .animate__fadeInLeft {
              opacity: 1;
            }

            .animate__fadeInRight {
              opacity: 1;
            }
          }

          .img_left_box:hover {
            .img {
              width: 742px;
              height: 100%;

              img {
                width: 100%;
                height: 100%;
                transform: scale(1.1, 1.1);
                transition: all 1s;
              }
            }

            .info_box {
              .info_mty {
                color: #2c7be5;
                transition: all 1s;
              }
            }
          }

          .img_right_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100%;

            .img {
              width: 742px;
              height: 100%;
              overflow: hidden;
              opacity: 0;

              img {
                width: 100%;
                height: 100%;
                transition: all 1s;
              }
            }

            .info_box {
              opacity: 0;
              width: 425px;
              height: 400px;
              display: flex;
              align-items: center;

              .info_mty {
                white-space: pre-wrap;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 28px;
                color: #666666;
                transition: all 1s;
              }
            }
          }

          .img_right_box:hover {
            .img {
              width: 742px;
              height: 100%;

              img {
                width: 100%;
                height: 100%;
                transform: scale(1.1, 1.1);
                transition: all 1s;
              }
            }

            .info_box {
              .info_mty {
                color: #2c7be5;
                transition: all 1s;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 830px) and (max-width: 1200px) {

  .box_oun .Company_profile_box .profile_box .for_box[data-v-194db4f0]:nth-child(1),
  .box_oun .Company_profile_box .profile_box .for_box[data-v-194db4f0]:nth-child(3) {
    justify-content: center;
  }

  .box_oun .Company_profile_box .profile_box .for_box[data-v-194db4f0]:nth-child(2),
  .box_oun .Company_profile_box .profile_box .for_box[data-v-194db4f0]:nth-child(4) {
    justify-content: center;
  }
}

@media (max-width: 1200px) {
  .box_oun {
    padding-bottom: 200px;

    .Company_profile_box {
      .info {
        width: auto;
        font-size: 12px;
        line-height: 16px;
      }

      .profile_box {
        width: auto;
        height: auto;
        margin: 50px auto 0;
        display: flex;
        flex-wrap: wrap;

        .for_box {
          width: 49%;
          height: 100%;
          display: flex;
          justify-content: center;
          margin-bottom: 38px;

          .number_box {
            //max-width: 106px;
            height: 100%;
            margin-left: 30px;

            .name {
              font-size: 10px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 19px;
              color: #1a1a1a;
              opacity: 1;
            }

            .num {
              margin-top: 20px;
              display: flex;
              align-items: flex-end;

              .countTo {
                font-size: 33px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                line-height: 61px;
                color: #2c7be5;
                opacity: 1;
              }

              span {
                font-size: 10px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 19px;
                color: #1a1a1a;
                opacity: 1;
                margin-left: 0px;
              }

              .txt_ou {
                //width: 3em;
                line-height: 10px;
                display: inline-block;
                white-space: normal;
                vertical-align: bottom;
                transform: translateY(-15px);
                margin-left: 5px;
              }
            }
          }

          .icon_box {
            width: auto;
            height: auto;
            margin-right: 30px;

            img {
              width: 42px;
              height: 42px;
            }
          }
        }

        .for_box:nth-child(1),
        .for_box:nth-child(3) {
          justify-content: flex-start;
        }

        .for_box>.number_box:nth-child(1),
        .for_box>.number_box:nth-child(3) {
          margin-left: 15px;
        }

        //.for_box>.number_box:nth-child(3){
        //  width: 106px;
        //}
        .for_box .act_clasee {
          transform: translateX(-25px);
        }

        .for_box:nth-child(2),
        .for_box:nth-child(4) {
          justify-content: flex-end;
        }

        .for_box>.icon_box:nth-child(2),
        .for_box>.icon_box:nth-child(4) {
          margin-right: 15px;
          margin-left: 10px;
        }

        .for_box1 {
          border-left: 1px solid #909090;
        }

        .actives .number_box {
          width: 116px !important;
        }
      }

      .profile_box>.for_box:nth-child(3n) {
        border-left: none;
      }

      .picety {
        margin: 19px auto 25px;
        width: 120%;
        height: 90px;
        margin-left: -10%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .culture_box {
        width: 100%;
        height: auto;

        .culture_center_box_pc {
          display: none;
        }

        .culture_center_box {
          padding: 0 15px;
          width: auto;
          display: block;
          min-height: 300px;
          margin: 0 auto;

          .culture_for_box {
            width: 100%;
            opacity: 1;
            margin-top: 25px;
            height: auto;
            overflow: hidden;

            .img_left_box {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              width: 100%;
              height: auto;

              .img {
                width: 100%;
                width: 100%;
                height: 186px;
                overflow: hidden;
                margin-bottom: 25px;

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  transition: all 1s;
                }
              }

              .info_box {
                width: 100%;
                height: auto;
                display: flex;
                align-items: center;

                .info_mty {
                  width: 100%;
                  white-space: pre-wrap;
                  font-size: 18px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 28px;
                  color: #666666;
                  transition: all 1s;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
